// ©2024 Austin App House. All rights reserved.
import React from 'react';

const FundingSourceCard = ({
  fundingSource, handlerVerify, handlerDelete, makePrimary, auth
}) => (
  <div className="block_tools">
    <div className="page_title">{fundingSource.bankName}</div>
    <div className="expires_block">Verification status: {fundingSource.status}</div>
    <div className="row_block">
      {fundingSource.isPrimary ? (
        <span className="label_primary">PRIMARY</span>
      ) : (
        <>
          {fundingSource.status === 'verified' ? (
            <a href="#" className="icon_stars" onClick={(e) => { e.preventDefault(); makePrimary(fundingSource.id); }}>Make Primary</a>
          ) : null}
          <a href="#" className="icon_delete" onClick={(e) => { e.preventDefault(); handlerDelete(fundingSource.id); }}>Remove</a>
          {auth.userType === 'superAdmin' && fundingSource.status !== 'verified' ? (
            <a href="#" className="icon_check" onClick={(e) => { e.preventDefault(); handlerVerify(fundingSource); }}>Verify</a>
          ) : null}
        </>
      )}
    </div>
  </div>
);

export default FundingSourceCard;
